<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title">Место работы</div>
      </v-col>
      <v-col cols="12">
        <v-select
          v-model="v.jobPlaceSelect.$model"
          :errorMessages="getValidationErrorText(v.jobPlaceSelect)"
          :disabled="disabled"
          :items="Object.values(JobPlaceDictionary)"
          placeholder="Не выбран"
          label="Место работы"
          outlined
					@blur="v.jobPlaceSelect.$touch"
        />
      </v-col>
    </v-row>

    <div
      v-if="v.jobPlaceSelect.$model === JobPlaceDictionary.ORGANIZATION"
      :key="JobPlaceDictionary.ORGANIZATION"
    >
      <v-row>
        <v-col cols="12">
          <DadataOrgField
            label="Наименование организации"
            outlined
            v-model="v.jobPlace[JobPlaceDictionary.ORGANIZATION].orgName.$model"
            :errorMessages="
              getValidationErrorText(
                v.jobPlace[JobPlaceDictionary.ORGANIZATION].orgName
              )
            "
            :disabled="disabled"
            :suggestions="suggestions"
            field="name"          
            @suggest="onSelect"
						@blur="v.jobPlace[JobPlaceDictionary.ORGANIZATION].orgName.$touch"
          />
        </v-col>
      </v-row>

      <AddressEGRUL
        :v="v.jobPlace[JobPlaceDictionary.ORGANIZATION]"
        :disabled="disabled"
      />

      <v-row>
        <v-col cols="4">
          <DadataOrgField
            v-model="v.jobPlace[JobPlaceDictionary.ORGANIZATION].ogrn.$model"
            :errorMessages="
              getValidationErrorText(
                v.jobPlace[JobPlaceDictionary.ORGANIZATION].ogrn
              )
            "
            :disabled="disabled"
            mask="#############"
            label="ОГРН "
            outlined
            :suggestions="suggestions"
            field="ogrn"          
            @suggest="onSelect"
						@blur="v.jobPlace[JobPlaceDictionary.ORGANIZATION].ogrn.$touch"
          />
        </v-col>
        <v-col cols="4">
          <DadataOrgField
            v-model="v.jobPlace[JobPlaceDictionary.ORGANIZATION].inn.$model"
            :errorMessages="
              getValidationErrorText(
                v.jobPlace[JobPlaceDictionary.ORGANIZATION].inn
              )
            "
            :disabled="disabled"
            mask="##########"
            label="ИНН"
            outlined
            :suggestions="suggestions"
            field="inn"          
            @suggest="onSelect"
						@blur="v.jobPlace[JobPlaceDictionary.ORGANIZATION].inn.$touch"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="v.jobPlace[JobPlaceDictionary.ORGANIZATION].kpp.$model"
            :errorMessages="
              getValidationErrorText(
                v.jobPlace[JobPlaceDictionary.ORGANIZATION].kpp
              )
            "
            :disabled="disabled"
            v-mask="KPP"
            label="КПП"
            outlined
						@blur="v.jobPlace[JobPlaceDictionary.ORGANIZATION].kpp.$touch"
          />
        </v-col>
      </v-row>
    </div>

    <div
      v-if="v.jobPlaceSelect.$model === JobPlaceDictionary.BUSINESSMAN"
      :key="JobPlaceDictionary.BUSINESSMAN"
    >
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="ФИО индивидуального предпринимателя "
            outlined
            v-model="v.jobPlace[JobPlaceDictionary.BUSINESSMAN].fio.$model"
            :errorMessages="
              getValidationErrorText(
                v.jobPlace[JobPlaceDictionary.BUSINESSMAN].fio
              )
            "
            :disabled="disabled"
						@blur="v.jobPlace[JobPlaceDictionary.BUSINESSMAN].fio.$touch"
          />
        </v-col>

        <v-col cols="12">
          <AddressStructuredField
            :value="v.jobPlace[JobPlaceDictionary.BUSINESSMAN].address.$model"
            @change="
              v.jobPlace[JobPlaceDictionary.BUSINESSMAN].address.$model = $event
            "
            :v="v.jobPlace[JobPlaceDictionary.BUSINESSMAN].address"
            :global-disabled="disabled"
            label="Место регистрации"
						@blur="v.jobPlace[JobPlaceDictionary.BUSINESSMAN].address.$touch"
          />
        </v-col>

        <v-col cols="4">
          <v-text-field
            v-model="v.jobPlace[JobPlaceDictionary.BUSINESSMAN].ogrn.$model"
            :errorMessages="
              getValidationErrorText(
                v.jobPlace[JobPlaceDictionary.BUSINESSMAN].ogrn
              )
            "
            :disabled="disabled"
            v-mask="['###############']"
            label="ОГРНИП"
            outlined
						@blur="v.jobPlace[JobPlaceDictionary.BUSINESSMAN].ogrn.$touch"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="v.jobPlace[JobPlaceDictionary.BUSINESSMAN].inn.$model"
            :errorMessages="
              getValidationErrorText(
                v.jobPlace[JobPlaceDictionary.BUSINESSMAN].inn
              )
            "
            :disabled="disabled"
            v-mask="['############']"
            label="ИНН"
            outlined
						@blur="v.jobPlace[JobPlaceDictionary.BUSINESSMAN].inn.$touch"
          />
        </v-col>
      </v-row>
    </div>

    <v-row
      v-if="v.jobPlaceSelect.$model === JobPlaceDictionary.IS_BUSINESSMAN"
      :key="JobPlaceDictionary.IS_BUSINESSMAN"
    >
      <v-col cols="4">
        <v-text-field
          v-model="v.ogrn.$model"
          :errorMessages="getValidationErrorText(v.ogrn)"
          :disabled="disabled"
          v-mask="['###############']"
          label="ОГРНИП"
          outlined
					@blur="v.ogrn.$touch"
        />
      </v-col>
      <v-col cols="4">
        <DateFieldCustom
          label="Дата гос. регистрации"
          :value="v.regDate.$model"
          @change="v.regDate.$model = $event"
          :errorMessage="v.regDate"
          :disabled="disabled"
          :max="new Date().toISOString()"
					@blur="v.regDate.$touch"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.emailUl.$model"
          :errorMessages="getValidationErrorText(v.emailUl)"
          :disabled="disabled"
          label="Адрес электронной почты, содержащейся в ЕГРИП"
          outlined
					@blur="v.emailUl.$touch"
        />
      </v-col>

      <v-col cols="6">
        <v-text-field
          label="Место гос. регистрации"
          outlined
          v-model="v.regPlace.$model"
          :errorMessages="getValidationErrorText(v.regPlace)"
          :disabled="disabled"
					@blur="v.regPlace.$touch"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AddressStructuredField from '@/components/base/AddressStructuredField';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import { getValidationErrorText } from '@/utils/validate';
import { JobPlaceDictionary } from '@/utils/dictionaries';
import AddressEGRUL from '@/components/services/NoticeRecovery/General/AddressEGRUL';
import DadataOrgField from '@/components/base/DadataOrgField';

export default {
  name: 'JobPlace',
  props: {
    v: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    AddressEGRUL,
    AddressStructuredField,
    DateFieldCustom,
    DadataOrgField,
  },
  data: () => ({
    suggestions: [],
    JobPlaceDictionary,
    getValidationErrorText,
  }),
  methods: {
    onSelect: function (item) {
      this.suggestions = [item];
      this.v.jobPlace[JobPlaceDictionary.ORGANIZATION].orgName.$model = item.name;
      this.v.jobPlace[JobPlaceDictionary.ORGANIZATION].inn.$model = item.inn;
      this.v.jobPlace[JobPlaceDictionary.ORGANIZATION].ogrn.$model = item.ogrn;
      this.v.jobPlace[JobPlaceDictionary.ORGANIZATION].kpp.$model = item.kpp;
      
      // this.v.regDate.$model = item.regDate;
      // this.v.email.$model = item.email;
      this.v.jobPlace[JobPlaceDictionary.ORGANIZATION].address.$model = {...item.address};
      this.v.jobPlace[JobPlaceDictionary.ORGANIZATION].addressesMatch.$model = true;
    }
  }  
};
</script>

<style scoped></style>
